import { API } from "aws-amplify";
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setStoreData } from "../../store/auth";
import handlV3 from "../../images/handl-v3.png"
export default function Downloads() {
  const [accountType, setAccountType] = useState("free");
  const [plans, setPlans] = useState({
    subscriptions: [],
    invoices: [],
    billings: {},
  });
  const [plansLoading, setPlansLoading] = useState(true);
  const [downloadUrlLoading, setDownloadUrlLoading] = useState(true);
  const [downloadURL, setDownloadURL] = useState("");
  const navigate = useNavigate();

  const { isAuthenticated, user, plan } = useSelector(
    (state) => state.auth.data || {}
  );
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(isAuthenticated);
    if (isAuthenticated && user) {
      getPlanFromProps();
    } else if (!isAuthenticated) {
      navigate("/");
    }
  }, []);
  console.log({
    plansLoading,
    downloadUrlLoading,
    accountType
  });

  useEffect(() => {
    if (plansLoading) return;
    setDownloadUrlLoading(true);
    const session = user.getSignInUserSession();
    const myInit = {
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      },
    };
    if (accountType == "paid") {
      API.get("HandLAPI", "/download", myInit)
        .then((response) => {
          console.log(response);
          setDownloadURL(response.url);
        })
        .catch((error) => {
          console.log(error.response);
        }).finally(() => setDownloadUrlLoading(false));
    } else {
      setDownloadURL(
        "https://downloads.wordpress.org/plugin/handl-utm-grabber.latest-stable.zip"
      );
      setDownloadUrlLoading(false)
    }
  }, [accountType, plansLoading]);

  const getPlanFromProps = async function () {
    setPlansLoading(true);
    const session = user.getSignInUserSession();

    const myInit2 = {
      queryStringParameters: {
        action: "plan",
      },
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      },
    };

    if (plan === null) {
      await API.get("HandLAPI", "/myaccount", myInit2)
        .then((response) => {
          console.log(response);
          setPlans(response);
          setStateFromPlans(response.subscriptions);

          if (response.subscriptions.length > 0) {
            dispatch(
              setStoreData({ data: { plan: response, AppEligible: false } })
            );
          }
          setPlansLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setPlansLoading(false);
        });
    } else {
      //local cache
      setPlans(plan);
      setPlansLoading(false);
      setStateFromPlans(plan.subscriptions);
      // plan.subscriptions.forEach((element) => {
      //   setStateForElement(element);
      // });
    }
  };
  const setStateFromPlans = (plans) => {
    let status = "free";
    plans.forEach((plan) => {
      if (plan["subscription_status"].toLowerCase() === "active" || plan["subscription_status"].toLowerCase() === "trialing" || plan["subscription_status"].toLowerCase() === "expiring") {
        status = "paid";
        // dispatch(setStoreData({ data: { AppEligible: true } }));
      }
    });
    setAccountType(status);
    return status;
  };

  return (
    <div
      className="max-w-sm bg-white border border-gray-200 rounded-lg shadow cursor-pointer"
      onClick={() => {
        if (plansLoading || !downloadURL) return;
        const link = document.createElement("a");
        link.href = downloadURL;
        // link.target = '_blank';
        link.click();
      }}
    >
      <div>
        <img className="rounded-t-lg" src={handlV3} alt="" />
      </div>
      <div className="p-5">
        <div>
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">
            UTM Grabber V3
          </h5>
        </div>
        <p className="mb-3 font-normal text-gray-700]">
          Track all the UTM variables (and more) as soon as user hits your
          website. No more missing conversions and no more headache.
        </p>
        <button disabled={plansLoading || downloadUrlLoading} className={`inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white disabled:bg-gray-700 disabled:cursor-progress bg-blue-700 rounded-lg hover:bg-blue-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300`}>
          Download
          {
            plansLoading || downloadUrlLoading ? <i className="fa fa-spin fa-spinner ml-1" /> : <svg
              className="w-3.5 h-3.5 ml-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 10"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 5h12m0 0L9 1m4 4L9 9"
              />
            </svg>
          }
        </button>
      </div>
    </div>
  );
}
